import { useSnackbar } from "@sagecentral/core-ui";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { ValidationSummary } from "components/shared";

type UseWorkItemWorkflowsStatusChangeSignature =
    (
        workflowInstanceId: number,
        status: boolean,
        name: string
    ) => () => Promise<boolean>;

const useWorkItemWorkflowsStatusChange = () => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);
    const { displaySnackbar } = useSnackbar();

    const handleStatusChange = async (workflowInstanceId: number, status: boolean, name: string) => {
        const resp = await fetcher(`/api/v3/workitems/workflows/${workflowInstanceId}/status`, {
            method: 'PATCH',
            body: JSON.stringify(status),
        }  , async r => {
            if (r.status === 400) {
                const data = await r.json();
                displaySnackbar('warning', <><ValidationSummary validationDetail={data} /></>);
                return true;
            } else {
                displaySnackbar('error', "Failed to update workflow instance.");
            }
            return true;
        });

        if (!resp.ok) {
            return false;
        }
        if(resp.ok){
            displaySnackbar('success', `Workflow ${name} updated successfully.`);
            return true;
        }
    };

    return handleStatusChange;
}

export default useWorkItemWorkflowsStatusChange;